/**
 * Get the support online form link for a specific country
 * @param {string} country - The country code
 * @returns {string} The support form URL for the country
 */
export const getSupportOnlineFormLink = (country) => {
  const countryLink = {
    FR: 'https://help.shipstation.com/hc/fr-fr/requests/new',
    NZ: 'https://help.shipstation.com/hc/en-au/requests/new',
    AU: 'https://help.shipstation.com/hc/en-au/requests/new',
    DE: 'https://help.shipstation.com/hc/de/requests/new ',
    GB: 'https://help.shipstation.com/hc/en-gb/requests/new',
    CA: 'https://help.shipstation.com/hc/en-ca/requests/new',
    default: 'https://help.shipstation.com/hc/en-us/requests/new',
  };
  return countryLink[country] || countryLink.default;
};
